import { createAction } from 'redux-actions';
export const RESET_CREATE_A_NEW_WORKFLOW = '@@lib/RESET_CREATE_A_NEW_WORKFLOW';
const resetCreateANewWorkflowAction = createAction(RESET_CREATE_A_NEW_WORKFLOW);
const resetCreateANewWorkflow = () => dispatch => {
  dispatch(resetCreateANewWorkflowAction());
};
export default resetCreateANewWorkflow;